import { useEffect, useRef } from "react";

const IDLE_MS = 60 * 60 * 1000; // 60 minutes
const EVENTS = ["pointermove", "keydown", "click", "scroll", "touchstart"] as const;

export function useIdleTimeout() {
  const lastActivity = useRef(Date.now());

  useEffect(() => {
    function resetTimer() {
      lastActivity.current = Date.now();
    }

    for (const ev of EVENTS) {
      window.addEventListener(ev, resetTimer, { passive: true });
    }

    const intervalId = setInterval(() => {
      if (Date.now() - lastActivity.current > IDLE_MS) {
        clearInterval(intervalId);
        // Sign out via API directly to avoid auth-client diamond dep with Bun bundler
        fetch("/api/auth/sign-out", { method: "POST", credentials: "include" }).finally(() => {
          window.location.href = "/login?reason=idle";
        });
      }
    }, 30_000);

    return () => {
      for (const ev of EVENTS) {
        window.removeEventListener(ev, resetTimer);
      }
      clearInterval(intervalId);
    };
  }, []);
}
